import { leagueOf } from '@penalty-cup/shared';
import { useCallback } from 'react';
import { Avatar } from '../components/Avatar.js';
import { useApp } from '../store.js';
import { useBackButton } from '../telegram-back.js';

/** Профиль: лига и статистика (с главного — по нажатию на аватар). */
export function Profile() {
  const me = useApp((s) => s.me);
  const setView = useApp((s) => s.setView);
  const back = useCallback(() => setView(null), [setView]);
  useBackButton(back);
  if (!me) return null;
  const league = leagueOf(me.rating);
  const s = me.stats;
  const rows: [string, number | string][] = [
    ['кубков', s.tournamentsWon],
    ['турниров', s.tournamentsPlayed],
    ['побед', s.matchesWon],
    ['матчей', s.matchesPlayed],
    ['голов', s.goals],
    ['сейвов', s.saves],
    ['идеальных ударов', s.perfectShots],
    ['лучшая серия', s.bestWinStreak],
  ];
  return (
    <main className="screen profile screen--nav">
      <Avatar me={me} size={88} />
      <h1 className="screen__title">{me.teamName ?? me.firstName}</h1>
      <p className="screen__lead" style={{ color: league.league.color }}>
        Лига {league.league.name} · рейтинг {me.rating}
      </p>
      <div className="profile__stats">
        {rows.map(([label, value]) => (
          <div key={label} className="stat">
            <b>{value}</b>
            <span>{label}</span>
          </div>
        ))}
      </div>
      {me.isAdmin && (
        <button type="button" className="chip" onClick={() => setView('admin')}>
          ⚙️ Админка
        </button>
      )}
      <button type="button" className="link" onClick={back}>
        На главный
      </button>
    </main>
  );
}
